import { useIntl } from "react-intl";

export const FirstHeader = ({
  className = "FirstHeaderDefault",
  text = "",
  style = {},
  onClick = () => {},
  ...props
}) => {
  const { messages } = useIntl();
  return (
    <h1
      className={`FirstHeaderDefault ${className}`}
      style={style}
      {...props}
      onClick={onClick}
    >
      {messages[text]}
    </h1>
  );
};
